import { render, staticRenderFns } from "./ComboboxMember.vue?vue&type=template&id=b6d230d2"
import script from "./ComboboxMember.vue?vue&type=script&lang=js"
export * from "./ComboboxMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports